'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _components = require('components');

var _zendesk = require('../../redux/modules/zendesk');

var _galleryArtworkFormValidation = require('../../utils/galleryArtworkFormValidation');

var _galleryArtworkFormValidation2 = _interopRequireDefault(_galleryArtworkFormValidation);

var _SubmitArtPopup = require('@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup');

var _SubmitArtPopup2 = _interopRequireDefault(_SubmitArtPopup);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  border: 'none',
  marginTop: '3.75em',
  width: '' + _css.sizes.innerMaxWidthTighter
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  border: '1px solid #333',
  margin: '200px auto',
  width: '' + (_css.sizes.innerMaxWidthTighter + 2)
}));

var SubmitArtPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'submitArt',
  fields: ['artworkUrl', 'name', 'email', 'title', 'tools', 'homeUrl', 'artStationUrl', 'acceptTos'],
  validate: _galleryArtworkFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createTicket: _zendesk.createTicket }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(SubmitArtPopupContainer, _React$Component);

  function SubmitArtPopupContainer(props) {
    (0, _classCallCheck3.default)(this, SubmitArtPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SubmitArtPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(SubmitArtPopupContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    _this.onOKClick = _this.onOKClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SubmitArtPopupContainer, [{
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var artworkUrl = values.artworkUrl,
          name = values.name,
          email = values.email,
          title = values.title,
          tools = values.tools,
          homeUrl = values.homeUrl,
          artStationUrl = values.artStationUrl;

      var comment = '\nArtwork Url: ' + artworkUrl + '\n';
      comment += 'Name: ' + name + '\n';
      comment += 'Email: ' + email + '\n';
      comment += 'Title: ' + title + '\n';
      comment += 'Tools Used: ' + tools + '\n';
      comment += 'Homepage Url: ' + homeUrl + '\n';
      comment += typeof artStationUrl !== 'undefined' ? 'Artstation Url: ' + artStationUrl + '\n' : '';

      var tag = 'MegascansGalleryRequest';
      var subject = 'Megascans - Gallery Artwork Showcase Request';

      var custom_fields = [{
        id: '360000990877',
        value: 'Artwork'
      }];
      return this.props.createTicket({ email: 'reports@quixel.se', comment: comment, tag: tag, name: name, subject: subject, custom_fields: custom_fields }).then(function () {
        _this2.setState({
          message: 'Submitted a request for featuring your artwork on our Gallery'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: 'onOKClick',
    value: function onOKClick() {
      if (this.state.message) {
        this.props.closePopup();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          artworkUrlInputProps = _props$fields.artworkUrl,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          titleInputProps = _props$fields.title,
          toolsInputProps = _props$fields.tools,
          homeUrlInputProps = _props$fields.homeUrl,
          artStationUrlInputProps = _props$fields.artStationUrl,
          acceptTosInputProps = _props$fields.acceptTos,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          childReference = _props.childReference;
      var _state = this.state,
          error = _state.error,
          message = _state.message;


      var terms = ['Images submitted must be at least 1920 x 1080 px.', 'Images submitted can be used by Quixel to promote the Megascans service online and in social media. Featured images will always be credited to the artist.'];

      return _react2.default.createElement(_SubmitArtPopup2.default, {
        icon: '/quixel_logo.png',
        artworkUrlInputProps: artworkUrlInputProps,
        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        titleInputProps: titleInputProps,
        toolsInputProps: toolsInputProps,
        homeUrlInputProps: homeUrlInputProps,
        artStationUrlInputProps: artStationUrlInputProps,
        terms: terms,
        acceptTos: acceptTosInputProps,
        error: error,
        message: message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        onOKClick: this.onOKClick,
        onChildRef: childReference
      });
    }
  }]);
  return SubmitArtPopupContainer;
}(_react2.default.Component)) || _class) || _class);

var SubmitArtwork = function (_React$Component2) {
  (0, _inherits3.default)(SubmitArtwork, _React$Component2);

  function SubmitArtwork() {
    (0, _classCallCheck3.default)(this, SubmitArtwork);
    return (0, _possibleConstructorReturn3.default)(this, (SubmitArtwork.__proto__ || (0, _getPrototypeOf2.default)(SubmitArtwork)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubmitArtwork, [{
    key: 'render',
    value: function render() {
      var isPopup = this.props.isPopup;


      if (isPopup) {
        return _react2.default.createElement(SubmitArtPopupContainer, this.props);
      }

      return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(SubmitArtPopupContainer, this.props)
      );
    }
  }]);
  return SubmitArtwork;
}(_react2.default.Component);

exports.default = SubmitArtwork;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubmitArtwork/SubmitArtwork.jsx
// module id = 2658
// module chunks = 0